export default "__VITE_ASSET__BpsGRSKe__"